import React, { useEffect } from 'react';
import Navbar from '../../../Components/HomeComponent/Navbar';
import FooterComponent from '../../../Components/Footer/FooterComponent';
import { FaFilter, FaUserCheck, FaBullseye, FaChartLine, FaArrowRight } from 'react-icons/fa';

const LeadQualification = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "AI Lead Qualification | ToxBox";
  }, []);

  const benefits = [
    {
      icon: <FaFilter size={32} color="#10b981" />,
      title: "Smart Filtering",
      description: "Automatically filter out low-quality leads so your team focuses only on high-potential prospects."
    },
    {
      icon: <FaUserCheck size={32} color="#10b981" />,
      title: "Instant Scoring",
      description: "Assign real-time scores to every lead based on behavior, demographics, and engagement intent."
    },
    {
      icon: <FaBullseye size={32} color="#10b981" />,
      title: "Precision Targeting",
      description: "Identify the decision-makers and route them instantly to the right sales  representative."
    },
    {
      icon: <FaChartLine size={32} color="#10b981" />,
      title: "Conversion Analytics",
      description: "Gain deep insights into your pipeline health and lead conversion rates with advanced reporting."
    }
  ];

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", backgroundColor: '#f8fafc', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />

      {/* Hero Section */}
      <div style={{
        padding: '160px 20px 100px',
        background: 'linear-gradient(135deg, #ecfdf5 0%, #ffffff 100%)',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: '800',
            color: '#064e3b',
            marginBottom: '24px',
            lineHeight: '1.2'
          }}>
            Stop Wasting Time on <br />
            <span style={{ color: '#10b981' }}>Unqualified Leads</span>
          </h1>
          <p style={{
            fontSize: '1.25rem',
            color: '#334155',
            marginBottom: '40px',
            maxWidth: '700px',
            margin: '0 auto 40px',
            lineHeight: '1.6'
          }}>
            Automate your lead qualification process with AI. Identify high-value prospects instantly and fast-track your sales cycle.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <a href="/demo-form" style={{
              padding: '16px 36px',
              background: '#10b981',
              color: 'white',
              borderRadius: '50px',
              fontWeight: '700',
              textDecoration: 'none',
              boxShadow: '0 10px 20px -5px rgba(16, 185, 129, 0.4)'
            }}>
              Start Qualifying Now
            </a>
          </div>
        </div>
      </div>

      {/* Benefits Grid */}
      <div style={{ padding: '100px 20px', background: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#0f172a' }}>Why Use AI for Lead Qualification?</h2>
            <p style={{ color: '#64748b', fontSize: '1.1rem', marginTop: '10px' }}>Maximize efficiency and revenue per rep.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '32px' }}>
            {benefits.map((item, index) => (
              <div key={index} style={{
                padding: '32px',
                borderRadius: '24px',
                background: '#f0fdf4',
                border: '1px solid #dcfce7',
                transition: 'transform 0.2s'
              }} className="hover:translate-y-[-5px]">
                <div style={{ marginBottom: '20px' }}>{item.icon}</div>
                <h3 style={{ fontSize: '1.4rem', fontWeight: '700', color: '#064e3b', marginBottom: '12px' }}>{item.title}</h3>
                <p style={{ color: '#4b5563', lineHeight: '1.6' }}>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Feature Highlight */}
      <div style={{ padding: '100px 20px', background: '#ecfdf5' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '60px', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: '300px' }}>
            <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '24px' }}>Real-Time Intent Analysis</h2>
            <p style={{ fontSize: '1.1rem', color: '#334155', lineHeight: '1.7', marginBottom: '30px' }}>
              Our AI doesn't just look at static data. It analyzes user behavior, website interactions, and chat history to determine true buying intent in real-time.
            </p>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {['Behavioral Scoring', 'Demographic Enrichment', 'Predictive Analytics'].map((feat, i) => (
                <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px', fontSize: '1.1rem', color: '#065f46' }}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#10b981' }}></div>
                  {feat}
                </li>
              ))}
            </ul>
          </div>
          <div style={{ flex: 1, minWidth: '300px', background: 'white', padding: '40px', borderRadius: '24px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #e5e7eb' }}>
              <div>
                <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>Lead Score</div>
                <div style={{ fontSize: '2.5rem', fontWeight: '800', color: '#10b981' }}>94/100</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>Status</div>
                <div style={{ fontSize: '1rem', fontWeight: '700', color: '#059669', background: '#d1fae5', padding: '4px 12px', borderRadius: '50px' }}>Hot Lead</div>
              </div>
            </div>
            <div style={{ color: '#374151', lineHeight: '1.6' }}>
              <strong>Recommendation:</strong> <br />
              Immediate follow-up required. High interest in Enterprise plan.
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={{ padding: '100px 20px', textAlign: 'center', background: '#064e3b', color: 'white' }}>
        <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '20px' }}>Ready to Scale Your Sales Pipeline?</h2>
        <p style={{ maxWidth: '600px', margin: '0 auto 40px', fontSize: '1.2rem', color: '#a7f3d0' }}>
          Join high-growth teams using ToxBox to close more deals faster.
        </p>
        <a href="/contact" style={{
          display: 'inline-flex', alignItems: 'center', gap: '10px',
          padding: '16px 40px', background: '#10b981', color: 'white',
          borderRadius: '50px', fontWeight: '700', fontSize: '1.1rem',
          textDecoration: 'none',
          boxShadow: '0 10px 15px -3px rgba(16, 185, 129, 0.4)'
        }}>
          Get Your Free Assessment <FaArrowRight />
        </a>
      </div>

      <FooterComponent />
    </div>
  );
};

export default LeadQualification;